import { ApiError } from '@app/api/errors';
import { ReportContext } from '@app/components/reports/types';
import { useGetReportResults } from '@shared/api/hooks/ccf/results';
import { CompanyReportResult } from '@shared/api/types';
import { createContext, useContext } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

const CCFReportResultContext =
  createContext<ReportContext<CompanyReportResult> | null>(null);

export function useCCFReportResult() {
  return useContext(
    CCFReportResultContext
  ) as ReportContext<CompanyReportResult>;
}

export default function CCFReportContextProvider() {
  const { pathname } = useLocation();
  const params = useParams();
  const report_uuid = params.report_uuid;

  const {
    data: reportResult,
    status: reportResultStatus,
    error: reportResultError,
  } = useGetReportResults(report_uuid!);

  const context: ReportContext<CompanyReportResult> = {
    result: reportResult!,
    resultStatus: reportResultStatus,
    resultError: reportResultError as ApiError,
    downloadMode: pathname.endsWith('/download'),
  };

  return (
    <CCFReportResultContext.Provider value={context}>
      <Outlet />
    </CCFReportResultContext.Provider>
  );
}
